import { all, call, delay, takeLatest, put, select } from 'redux-saga/effects';
import { mineActions, selectMine } from '$store/mine/index';
import { Api } from '$api';
import { batchActions } from '$store';
import { mainActions } from '$store/main';
import { toastActions } from '$store/toast';
import { getRandomInt, getStorageItem } from '$utils';

function* loadWorker() {
  try {
    const data = yield call(Api.get, '/mine', {
      params: {
        onboarded: getStorageItem('mine_onboarding_passed') === 'yes' ? 1 : 0,
      },
    });
    yield put(
      batchActions(
        mineActions.setCoins(data.coins),
        mineActions.setSquad(data.squad),
        mineActions.setLoadingStatus(''),
        mainActions.setUser(data.squadOwner),
        mineActions.setEnergy(data.energy),
        mineActions.setEnergyLimit(data.energyLimit),
        mineActions.setEarnPerShake(data.earnPerShake),
        mineActions.setOnboardingPassed(data.onboardingPassed),
      ),
    );
    yield put(mineActions.setTS(data.ts));
  } catch (e) {
    if (e.code === 'cant_earn') {
      yield put(mineActions.setCantEarn(true));
    } else {
      yield delay(3000);
      yield call(loadWorker);
    }
  }
}

let counter = 0;

function* shakeWorker() {
  try {
    const { earnPerShake, energy, ts, energyLimit, energyDiff } = yield select(
      selectMine,
    );
    const estimatedEnergy = estimateEnergy(energy, ts, energyLimit) - energyDiff;
    if (estimatedEnergy >= earnPerShake) {
      yield call(startAnimation, earnPerShake);
      counter++;
    }

    if (counter === 0) {
      return;
    }

    yield delay(3000);

    let clicks = counter;
    counter = 0;
    const data = yield call(Api.post, '/mine/earn', {
      timestamp: Math.floor(Date.now() / 1000),
      clicks,
    });
    yield put(
      batchActions(mineActions.setCoins(data.coins), mineActions.setEnergy(data.energy)),
    );
    yield put(mineActions.setTS(data.ts));
  } catch (e) {
    console.log('shakeWorker', e);
  }
}

function* loadTopWorker() {
  try {
    const data = yield call(Api.get, '/mine/squad/top', {
      params: {
        onboarded: getStorageItem('mine_onboarding_passed') === 'yes' ? 1 : 0,
      },
    });
    yield put(
      batchActions(
        mainActions.setUsers(data.users),
        mineActions.setTopItems(data.items),
        mineActions.setTopTotalCount(data.totalCount),
        mineActions.setTopLoadingStatus(''),
        mineActions.setOnboardingPassed(data.onboardingPassed),
      ),
    );
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
    yield put(mineActions.setTopLoadingStatus('failed'));
  }
}

function* loadExploreWorker() {
  try {
    const data = yield call(Api.get, '/mine/explore');
    yield put(
      batchActions(
        mineActions.setExplore(data.cards),
        mineActions.setExploreLoadingStatus(''),
        mainActions.setUsers(data.users),
      ),
    );
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
    yield put(mineActions.setExploreLoadingStatus('failed'));
  }
}

export function* mineSaga() {
  yield all([
    takeLatest(mineActions.load, loadWorker),
    takeLatest(mineActions.shake, shakeWorker),
    takeLatest(mineActions.loadTop, loadTopWorker),
    takeLatest(mineActions.loadExplore, loadExploreWorker),
  ]);
}

function startAnimation(amount: number) {
  const el = document.createElement('div');
  el.classList.add('mine_animation_item');
  el.innerHTML = `+${amount}`;
  el.style.top = `${getRandomInt(200, window.innerHeight - 250)}px`;
  el.style.left = `${getRandomInt(50, window.innerWidth - 100)}px`;
  document.body.appendChild(el);

  setTimeout(() => {
    document.body.removeChild(el);
  }, 2800);
}

const RECOVERY_TIME = 60 * 60;
export function estimateEnergy(energy, ts, energyLimit) {
  const currentTime = Math.floor(Date.now() / 1000);

  const elapsedTime = currentTime - ts;
  const recoveredEnergy = Math.floor((elapsedTime * energyLimit) / RECOVERY_TIME);

  let newEnergy = Math.floor(energy + recoveredEnergy);
  if (newEnergy > energyLimit) {
    newEnergy = energyLimit;
  }

  return newEnergy;
}
